import React, { useRef, useState, useEffect } from 'react';
import './ExpandingTeamCard.css';
import linkedin from '../assets/icons/linkedin.svg';
import philteamfoto from '../assets/about/Phil_Teamfoto.webp';
import maxiteamfoto from '../assets/about/Maxi_Teamfoto.webp';
import robot3_comp from '../assets/about/robot3_comp.webp';
import robot3_webm from '../assets/about/robot3_comp.webm';
import robot3_mp4 from '../assets/about/robot3_comp.mp4';

const teamMembers = [
  {
    id: 1,
    name: 'Philipp Fuchs',
    role: 'CEO & Founder',
    image: philteamfoto,
    linkedin: 'https://www.linkedin.com/in/philippfuchs-blcks'
  },
  {
    id: 2,
    name: 'Maximilian Dirnberger',
    role: 'COO & Head of Sales',
    image: maxiteamfoto,
    linkedin: 'https://www.linkedin.com/in/maximilian-dirnberger-074b99299/'
  },
  {
    id: 3,
    name: 'QUBE',
    role: 'Chief Problem Solver',
    image: robot3_comp,
    videoWebm: robot3_webm,
    videoMp4: robot3_mp4,
    linkedin: 'https://www.linkedin.com/in/philippfuchs-blcks'
  }
];

const ExpandingTeamCard = () => {
  const videoRef = useRef(null);
  const [activeCard, setActiveCard] = useState(null);

  // Check if device is touch-enabled
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  
  useEffect(() => {
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  const handleCardInteraction = (cardId) => {
    if (isTouchDevice) {
      // Toggle active state on touch
      if (activeCard === cardId) {
        setActiveCard(null);
        if (cardId === 3 && videoRef.current) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }
      } else {
        setActiveCard(cardId);
        if (cardId === 3 && videoRef.current) {
          videoRef.current.play().catch(error => {
            console.error('Error playing video:', error);
          });
        }
      }
    } else {
      // For non-touch devices, just set the active card
      setActiveCard(cardId);
      if (cardId === 3 && videoRef.current) {
        videoRef.current.play().catch(error => {
          console.error('Error playing video:', error);
        });
      }
    }
  };

  const handleMouseLeave = () => {
    if (!isTouchDevice) {
      setActiveCard(null);
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  };

  return (
    <div className="expanding-cards-container">
      {teamMembers.map((member) => (
        <div 
          key={member.id} 
          className={`expanding-card ${member.id === 3 ? 'has-video' : ''} ${activeCard === member.id ? 'active' : ''}`}
          onMouseEnter={() => !isTouchDevice && handleCardInteraction(member.id)}
          onMouseLeave={handleMouseLeave}
          onClick={() => isTouchDevice && handleCardInteraction(member.id)}
        >
          <img 
            src={member.image} 
            alt={member.name} 
            className={`card-image ${member.id === 3 && activeCard === member.id ? 'hidden' : ''}`}
            loading="lazy"
          />
          {member.id === 3 && (
            <video
              ref={videoRef}
              className={`card-video ${activeCard === member.id ? '' : 'hidden'}`}
              loop
              muted
              playsInline
              preload="none"
            >
              <source src={member.videoWebm} type="video/webm" />
              <source src={member.videoMp4} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
          <div className="card-content">
            <div className="card-text">
              <h3 className="card-name">{member.name}</h3>
              <p className="card-role">{member.role}</p>
            </div>
            <a 
              href={member.linkedin} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-blue-400 transition-colors"
            >
              <img 
                src={linkedin} 
                alt="LinkedIn" 
                className="linkedin-icon"
              />
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExpandingTeamCard;